import { render, staticRenderFns } from "./bugInfo.vue?vue&type=template&id=08a45b82&scoped=true"
import script from "./bugInfo.vue?vue&type=script&lang=js"
export * from "./bugInfo.vue?vue&type=script&lang=js"
import style0 from "./bugInfo.vue?vue&type=style&index=0&id=08a45b82&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08a45b82",
  null
  
)

export default component.exports